/*
  © Copyright Rohan Tinna

  This page is used to carry out tests.

*/

import React from "react";

function Test(props) {
  return (
    <div>
      <div id="ticker">
        <div className="ticker-element">#WebDevelopment</div>
        <div className="ticker-element">#Business</div>
        <div className="ticker-element">#Economics</div>
        <div className="ticker-element">#Fintech</div>
        <div className="ticker-element">#Politics</div>
        <div className="ticker-element">#Globalisation</div>
        <div className="ticker-element">#TooBigToFail</div>
        <div className="ticker-element">#GenZ</div>
      </div>
    </div>
  );
}

export default Test;
